/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_itemSearch = {
    readonly totalResults: number | null;
    readonly pageType: string | null;
    readonly searchCorrections: {
        readonly originalSearchTerm: string | null;
    } | null;
    readonly canBeClassificationSearch: boolean | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly internalBuyLinks: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SharedRespMoreWaysToBrowse_internalBuyLinks">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedForceSearchLink_itemSearch" | "SbSharedSearchSuggestions_itemSearch" | "SbRespNullSearchResults_itemSearch" | "SbSharedPageBreadcrumbs_itemSearch" | "SbSharedTitle_itemSearch" | "SbSharedTopTileController_itemSearch" | "SbRespCategoryTiles_itemSearch" | "SbSharedFollowSearchProvider_itemSearch" | "SbSharedBillboardAd_itemSearch" | "SbRespPriceTiles_itemSearch" | "SbRespTradeOnApprovalPromoBanner_itemSearch" | "SbRespMainContent_itemSearch" | "SuspectedTradeUserLoader_itemSearch">;
    readonly " $refType": "SbRespComponents_itemSearch";
};
export type SbRespComponents_itemSearch$data = SbRespComponents_itemSearch;
export type SbRespComponents_itemSearch$key = {
    readonly " $data"?: SbRespComponents_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespComponents_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespComponents_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "searchCorrections",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchCorrectionsType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "originalSearchTerm",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canBeClassificationSearch",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "internalBuyLinks",
      "storageKey": null,
      "args": null,
      "concreteType": "InternalBuyLinkType",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SharedRespMoreWaysToBrowse_internalBuyLinks",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedForceSearchLink_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPageBreadcrumbs_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTopTileController_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespCategoryTiles_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedBillboardAd_itemSearch",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SbRespPriceTiles_itemSearch",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespTradeOnApprovalPromoBanner_itemSearch",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '5315c249cf0e4430249c0dc6b170e650';
export default node;
